import { Component, Input, OnInit } from '@angular/core';
import { SubTitleWrapper } from 'src/app/classes';
import { Location } from '../../../classes';

@Component({
  selector: 'app-location-preview',
  templateUrl: './location-preview.component.html',
  styleUrls: ['./location-preview.component.css']
})
export class LocationPreviewComponent implements OnInit {

  preview: string;
  subTitles: SubTitleWrapper[];

  _location: Location;
  @Input() set location(location: Location){
    this._location = location;
    var preview = "";
    var city = "";
    let subTitles: SubTitleWrapper[] = [];
    if(location.address){
      if(location.address.addressstreet) preview += location.address.addressstreet + " ";
      if(location.address.addresshousenumber) preview += location.address.addresshousenumber;
      if(location.address.addresszipcode) city += location.address.addresszipcode + " ";
      if(location.address.addresscity) city += location.address.addresscity;
      subTitles.push({ value: city, type: "Stadt" } as SubTitleWrapper);
      if(location.locationpart) subTitles.push({ value: location.locationpart, type: "Geb.-teil" });
    }
    this.preview = preview;
    this.subTitles = subTitles;
  }
  get location(): Location {
    return this._location;
  }

  constructor() { }

  ngOnInit(): void {
  }

}
